<template>
  <v-overlay z-index="9999" :value="value" @input="$emit('input', $event)">
    <div class="cookie-consent-dialog">
      <header>
        <div class="subtitle-1">Cookies i Registret</div>
      </header>
  
      <main>
        <p class="body-1 mb-0">
          Nödvändiga cookies används alltid. Med ditt samtycke använder vi även analyscookies för att se hur sidorna används och för att kunna visa en kort enkät. Du kan ändra ditt val när som helst.
          <a target="_blank" href="https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2026/10/Cookiepolicy-Mina-Sidor-och-Registret.pdf">Läs mer om cookies.</a>
        </p>
      </main>
  
      <footer>
        <div class="d-flex align-center justify-end cookie-consent-dialog__actions">
          <v-btn class="cookie-consent-dialog__actions-btn" @click="save(false)">Neka analyscookies</v-btn>
          <v-btn class="cookie-consent-dialog__actions-btn" @click="save(true)">Godkänn analyscookies</v-btn>
        </div>
      </footer>
    </div>
  </v-overlay>
</template>

<script>
import { getConsent, setConsent, loadConsentScript, unloadConsentScript } from '@/utils/consent'
import { mapGetters, mapActions } from 'vuex';
import API from '@/services/api'

export default {
  name: 'CookieConsentDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      allowStats: getConsent() === 'accepted',
    }
  },

  computed: {
    ...mapGetters('user', ['selectedUser']),
  },

  watch: {
    // Sync the switch with the stored choice every time the dialog opens
    value(open) {
      if (open) {
        this.allowStats = getConsent() === 'accepted'
      }
    },

    selectedUser: {
      immediate: true,
      handler(userData) {
        if (!userData) return

        const consent = getConsent()

        if (consent !== null) return

        if (userData.allowAnalytics !== null) {
          return
        }
      }
    }
  },

  methods: {
    ...mapActions("user", ["setSelectedUser"]),

    save(allowStats) {
      setConsent(allowStats ? 'accepted' : 'rejected')

      if (allowStats) {
        loadConsentScript()
      } else {
        unloadConsentScript()
      }

      if (this.selectedUser) {
        API.setUser({
          ...this.selectedUser,
          allowAnalytics: allowStats
        })
          .then(response => {
            if (!this.selectedUser.id) {
              this.setSelectedUser(response.data)
            }

            this.$events.fire('showInfo', 'Användaren sparad.')

            if (!allowStats) {
              window.location.reload()
            }
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })

        return
      }

      if (!allowStats) {
        window.location.reload()
        return
      }

      this.$emit('input', false)
    }
  },
}
</script>

<style lang="scss" scoped>
.cookie-consent-dialog {
  position: fixed;
  width: 100%;
  z-index: 9999;
  max-width: 880px;
  background-color: #FFF;
  padding: 32px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  left: 50%;
  bottom: 0;
  color: #000000de;
  transform: translate(-50%, 0);
  animation: cookie-consent-dialog-enter 300ms ease-out;

  &__actions {
    gap: 8px;
  }

  @media (max-width: 600px) {
    &__actions {
      flex-wrap: wrap;
      gap: 18px;

      &-btn {
        width: 100%;
      }
    }
  }

  @media (max-width: 900px) {
    border-radius: 16px 16px 0 0;
  }

  @media (min-width: 901px) {
    top: 50%;
    bottom: auto;
    transform: translate(-50%, -50%);
    animation-name: cookie-consent-dialog-enter-centered;
  }
}

@keyframes cookie-consent-dialog-enter {
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes cookie-consent-dialog-enter-centered {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-50% + 20px));
  }

  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .cookie-consent-dialog {
    animation: none;
  }
}
</style>